<template>
    <profile-password :on-change="changePassword" />
</template>
<script>
    import { mapActions } from 'vuex';
    import { changePassword } from '../../../services/api/account';
    import ProfilePassword from "./ProfilePassword.vue";

    export default {
        name: 'profile-password-container',
        components: {
            ProfilePassword,
        },
        methods: {
            ...mapActions('notification', ['show']),

            changePassword(values) {
                return changePassword(values)
                    .then((res) => {
                        this.show('Ваш пароль изменен');
                    })
            },
        },
    }
</script>



// WEBPACK FOOTER //
// ProfilePasswordContainer.vue?b7e1725e